<template>
  <div v-if="currentUser" class="add-recommendation-page">
    <div class="page-header">
      <h1>Stwórz zalecenie</h1>
      <button class="btn-outline" @click="$router.push('/dla-biznesu/profile/recommendations')">Wróć do listy</button>
    </div>

    <div class="section-card" v-if="myServices && employees">
      <ServiceModal />
      <div class="section-card-header">
        <h2>Krok 1: Wybierz usługę</h2>
      </div>

      <div class="table-wrap">
        <table class="services-table">
          <thead>
          <tr>
            <th>Nazwa</th>
            <th>Pracownik</th>
            <th>Akcje</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="service in myServices" :key="service.service.id">
            <td>{{ service.service.name }}</td>
            <td>
              {{
                service.service.employee_id
                    ? `${employees.filter(item => item.id == service.service.employee_id)[0].firstname} ${employees.filter(item => item.id == service.service.employee_id)[0].lastname}`
                    : 'brak pracownika'
              }}
            </td>
            <td class="actions-cell">
              <button class="btn-icon" @click="$router.push({path: `/dla-biznesu/profile/recommendations/add`, query: {serviceID: service.service.id}})">
                <img src="@/assets/icons/eye-fill.svg" alt="podgląd usługi">
              </button>
              <button class="btn-icon" @click="choosedServiceId = service.service.id">
                <img src="@/assets/icons/square-fill.svg" alt="wybierz" v-if="choosedServiceId == service.service.id">
                <img v-else src="@/assets/icons/square.svg" alt="wybierz">
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="section-card" v-if="choosedServiceId">
      <div class="section-card-header">
        <h2>Krok 2: Wybierz datę wizyty</h2>
      </div>
      <div class="date-choose">
        <input type="date" name="visitDate" id="visitDate" v-model="visitDate" @input="getVisits()">
      </div>
    </div>

    <div class="section-card" v-if="choosedServiceId && visitDate && visits">
      <div class="section-card-header">
        <h2>Krok 3: Wybierz wizytę</h2>
      </div>

      <div v-if="visits.length > 0" class="visit-times">
        <button
            class="visit-time"
            :class="{ active: choosedVisit == visit }"
            @click="() => { choosedVisit = visit; getUserData(); }"
            v-for="visit in visits"
            :key="visit.id"
        >
          {{ visit.time }}
        </button>
      </div>

      <div v-else class="empty-state">
        <p>Brak wizyt dla wybranej daty.</p>
      </div>
    </div>

    <div class="section-card" v-if="choosedServiceId && visitDate && choosedVisit && userData">
      <div class="section-card-header">
        <h2>Krok 4: Wyślij zalecenie</h2>
      </div>

      <div class="target-info">
        <span>Dla:</span>
        <b>{{ userData.firstname }} {{ userData.lastname }}</b>
        <b>{{ userData.pets.filter(pet => choosedVisit.pet_id == pet.id)[0].pet_name }}</b>
      </div>

      <form class="send-form" @submit.prevent="sendRecomm()">
        <label for="recommContent">Treść zalecenia*</label>
        <textarea required v-model="newRecomm.content" name="recommContent" id="recommContent"></textarea>

        <label for="recommPhoto1">Grafika 1</label>
        <input type="file" @change="(e) => newRecomm.photo1 = e.target.files[0]" name="recommPhoto1" id="recommPhoto1" accept="image/png, image/jpeg">

        <label for="recommPhoto2">Grafika 2</label>
        <input type="file" @change="(e) => newRecomm.photo2 = e.target.files[0]" name="recommPhoto2" id="recommPhoto2" accept="image/png, image/jpeg">

        <div class="form-actions">
          <button type="submit" class="btn-primary">Wyślij</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import axios from 'axios';
import authHeader from '@/services/auth-header';
import ServiceModal from '@/components/SpecialComponents/ServiceModal.vue';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'BizProfileCreateRecommendation',
  setup() {
    useMeta({ title: 'Stwórz zalecenie' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      myServices: null,
      employees: null,
      choosedServiceId: null,
      visitDate: null,
      visits: null,
      choosedVisit: null,
      userData: null,
      newRecomm: {
        content: '',
        photo1: null,
        photo2: null
      }
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  components: {
    ServiceModal
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 2) {
      this.$router.push('/login');
    }
    if (this.appStore.isSubscribed) {
      this.getMyServices();
      this.getEmployees();
    } else {
      this.$router.push('/dla-biznesu/profile/user-data');
    }
  },
  methods: {
    getUserData() {
      if (this.choosedVisit) {
        axios.get(`/User/${this.choosedVisit.user_id}`).then(res => {
          this.userData = res.data;
        });
      }
    },
    getVisits() {
      axios.get(`/CalendarItemsForService/${this.choosedServiceId}`).then(res => {
        this.visits = res.data.filter(item => item.date == this.visitDate && item.user_id);
      });
    },
    getMyServices() {
      axios.get(`/UserService/${this.currentUser.id}`).then(res => {
        this.myServices = res.data;
      }).catch(() => {});
    },
    getEmployees() {
      axios.post(`/Users`, { main_id: this.currentUser.id, page: 1, limit: 100 }, authHeader())
          .then(res => {
            this.employees = res.data.items;
          }).catch(() => {});
    },
    sendRecomm() {
      if (this.choosedVisit && this.userData) {
        const ob = {
          pet_id: this.choosedVisit.pet_id,
          content: `${this.userData.firstname} ${this.userData.lastname},${this.userData.pets.filter(pet => this.choosedVisit.pet_id == pet.id)[0].pet_name}|${this.newRecomm.content}`,
        };
        if (this.newRecomm.photo1) {
          ob.photo = this.newRecomm.photo1;
        }
        if (this.newRecomm.photo2) {
          ob.second_photo = this.newRecomm.photo2;
        }
        axios.post(`/Recommendation`, ob, {
          headers: {
              ['Content-Type']: 'multipart/form-data'
          }
        }).then(() => {
          this.appStore.setIsSuccess('Pomyślnie wysłano zalecenie');
          this.$router.push('/dla-biznesu/profile/recommendations');
        }).catch(() => {});
      }
    }
  }
};
</script>

<style scoped lang='scss'>
.add-recommendation-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}
.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .08);
  padding: 20px;
  margin-bottom: 16px;
}

.section-card-header h2 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
}

.table-wrap {
  margin-top: 12px;
  overflow-x: auto;
}

.services-table {
  width: 100%;
  min-width: 700px;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}
.services-table th {
  background: #f9fafb;
  color: #374151;
  font-size: 1.4rem;
  font-weight: 700;
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
}
.services-table td {
  padding: 12px;
  font-size: 1.4rem;
  border-bottom: 1px solid #f1f5f9;
}
.services-table tr:last-child td {
  border-bottom: none;
}
.services-table tr:hover td {
  background: #fcfcfd;
}

.actions-cell {
  display: flex;
  gap: 8px;
}

.date-choose {
  margin-top: 10px;
}
.date-choose input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
}

.visit-times {
  margin-top: 12px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.visit-time {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 12px;
  background: #fff;
  cursor: pointer;
  font-size: 1.4rem;
}
.visit-time:hover {
  border-color: #10b981;
}
.visit-time.active {
  border-color: #f97316;
  color: #f97316;
  font-weight: 700;
}

.target-info {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 8px 0 14px;
}
.target-info span {
  color: #6b7280;
}
.target-info b {
  color: #1f2937;
  font-size: 1.5rem;
}

.send-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 560px;
}
.send-form label {
  font-size: 1.4rem;
  color: #374151;
  font-weight: 600;
}
.send-form textarea,
.send-form input {
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 1.4rem;
  outline: none;
}
.send-form textarea {
  min-height: 140px;
  resize: vertical;
}
.send-form textarea:focus,
.send-form input:focus {
  border-color: #10b981;
}

.form-actions {
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.btn-primary,
.btn-outline,
.btn-green {
  border: none;
  border-radius: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 600;
}
.btn-primary {
  background: #f97316;
  color: #fff;
}
.btn-primary:hover { background: #ea6c0a; }

.btn-outline {
  background: #fff;
  color: #1f2937;
  border: 1px solid #d1d5db;
}
.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-green {
  background: #10b981;
  color: #fff;
}
.btn-green:hover { background: #059669; }

.btn-icon {
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.btn-icon img {
  width: 18px;
  height: 18px;
}

.empty-state {
  text-align: center;
  color: #9ca3af;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  padding: 24px;
}

@media (max-width: 480px) {
  .add-recommendation-page {
    padding: 16px 12px;
  }
  .page-header h1 {
    font-size: 2.2rem;
  }
  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }
  .btn-primary,
  .btn-outline,
  .btn-green {
    width: 100%;
    text-align: center;
  }
}
</style>